export const examAdminErrorPages = {
  notFoundPage: {
    subtitle: "ページが見つかりません",
    backToDashboard: "プラットフォーム概要へ戻る",
  },
  accessDenied: {
    subtitle: "このアカウントでは現在のページにアクセスできません",
    backToDashboard: "プラットフォーム概要へ戻る",
  },
  runtimeError: {
    title: "管理ポータルで予期しないエラーが発生しました",
    subtitle: "ページを更新するか、ダッシュボードへ戻ってから再度お試しください。",
  },
};
